import React from 'react'

/**
 * Modulo Radar de Churn: sinal concentrico — o alerta que se propaga a partir
 * do cliente. (IconPark "broadcast".)
 */
export function ModuloRadarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="2" stroke="#fff" strokeWidth="1.6" />
      <path
        d="M8.2 8.2a5.4 5.4 0 000 7.6M15.8 8.2a5.4 5.4 0 010 7.6M5.4 5.4a9.4 9.4 0 000 13.2M18.6 5.4a9.4 9.4 0 010 13.2"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  )
}
